import { Component, Input, OnChanges } from '@angular/core';

import { TeamModel } from '../../../../../../reducers/orm/team/team.model';

@Component({
  standalone: false,
  selector: 'timesheet-total-timesheet-add',
  templateUrl: './timesheet-total-timesheet-add.component.html',
})
export class TimesheetTotalTimesheetAddComponent implements OnChanges {
  @Input()
  employeeId: string;
  @Input()
  team: TeamModel;
  @Input()
  date: string;
  @Input()
  dayIsClosed: boolean;

  modalData = {};

  ngOnChanges() {
    this.modalData = { employee: this.employeeId };
    if (this.team) {
      this.modalData = { ...this.modalData, team: this.team.id, department: this.team.department_id };
    }
    if (this.date) {
      this.modalData = { ...this.modalData, date: this.date };
    }
  }
}
